module.exports = __webpack_public_path__ + "static/media/flight_wings.67106ca6.png";